import Layout from "@/layouts/layout";
import PageHeading from "@/components/layout/PageHeading";

export default function ParentsGuidePage() {
  return (
    <Layout>
      ,
      <PageHeading title="Parents Guide" subtitle="Coming soon." />
      <div className="px-6 py-8 xl:px-24 xl:py-16">
        {/* uhhh mor context here ig */}
      </div>
    </Layout>
  );
}
